module.exports = __webpack_public_path__ + "img/item6.a652e982.png";